/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      function randomizePost( initialLoad = false ) {
        $( '.random-post__wrapper' ).addClass( 'is-loading' );

        const data = {
          'current_post': $( '.blog-page--single' ).attr( 'data-post-id' ),
          'current_random_post': $( '.random-post' ).attr( 'data-post-id' ),
          'initial_load': initialLoad,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'blog/randomizePost', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '.random-post__wrapper' ).html( data.post ).removeClass( 'is-loading' );
            $( '.random-post__wrapper a' ).trigger( 'focus' );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }

      randomizePost( true );

      $( '.randomize-post' ).on( 'click', function() {
        randomizePost();
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'blog', COMPONENT );
} )( app );
